import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PageLayout from '../UI/PageLayout';
import ProjectList from './ProjectList';
import ProjectHome from './ProjectHome';
import DataCollectionPage from './DataCollectionPage';
import DataProcessingPage from './DataProcessingPage';
import StagePage from './StagePage';
import './CompassPortal.css';

const CompassPortalPage = () => {
    return (
        <PageLayout
            title="Compass Portal"
            content={
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
                    <Routes>
                        <Route path="/" element={<ProjectList />} />
                        <Route path="/:projectId" element={<ProjectHome />} />
                        <Route path="/:projectId/data-collection" element={<DataCollectionPage />} />
                        <Route path="/:projectId/data-processing" element={<DataProcessingPage />} />
                        <Route path="/:projectId/data-validation" element={<StagePage stageId="data-validation" />} />
                        <Route path="/:projectId/data-modelling" element={<StagePage stageId="data-modelling" />} />
                        <Route path="/:projectId/compass-delivery" element={<StagePage stageId="compass-delivery" />} />
                    </Routes>
                </div>
            }
        />
    );
};

export default CompassPortalPage;
